import { render, staticRenderFns } from "./PersonalSettingForm.vue?vue&type=template&id=11ffff52&scoped=true&"
import script from "./PersonalSettingForm.vue?vue&type=script&lang=js&"
export * from "./PersonalSettingForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSettingForm.vue?vue&type=style&index=0&id=11ffff52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffff52",
  null
  
)

export default component.exports